module.exports = __webpack_public_path__ + "static/media/Pod_lesem.a9912862.md";